import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';
import urlUtils from '../../../utils/urlutils';
import workflowUtils from '../../../utils/workflowUtils';
import startupConfig from '../../../config/startupConfig';

const { registrationMode, portal } = workflowUtils.getRegistrationModeAndPortal();
const invitationCode = urlUtils.getQuerystring('invitationCode');
const inviterRole = urlUtils.getQuerystring('inviterRole');
const config = startupConfig.get();

export const initialState = {
  isLoading: false,
  loadingMessage: null,
  loadingVariant: 'default',
  portal,
  registrationMode,
  invitationCode,
  inviterRole,
  isConfigurationSet: false,
  configuration: config,
  isInvited: false,
  isBrokerInvited: false,
  userJourneyAccountType: '',
};

const reducer = handleActions(
  {
    [actionTypes.SHOW_MAIN_LOADING]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      loadingMessage: payload,
      loadingVariant: 'default',
    }),
    [actionTypes.HIDE_MAIN_LOADING]: (state) => ({
      ...state,
      isLoading: false,
      loadingMessage: null,
    }),
    [actionTypes.SHOW_MAIN_LOADING_AS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      loadingMessage: payload,
      loadingVariant: 'success',
    }),
    [actionTypes.RESET_INVITATION_CODE]: (state) => ({
      ...state,
      invitationCode: null,
    }),
    [actionTypes.SET_INVITATION_CODE]: (state, { payload }) => ({
      ...state,
      invitationCode: payload,
    }),
    [actionTypes.RESET_INVITER_ROLE]: (state) => ({
      ...state,
      inviterRole: null,
    }),
    [actionTypes.SET_INVITER_ROLE]: (state, { payload }) => ({
      ...state,
      inviterRole: payload,
    }),
    [actionTypes.SET_PORTAL]: (state, { payload }) => ({
      ...state,
      portal: payload,
    }),
    [actionTypes.GET_STARTUP_CONFIG_FULFILLED]: (state, { payload }) => ({
      ...state,
      isConfigurationSet: true,
      configuration: payload.data,
    }),
    [actionTypes.SET_INVITED_STATUS]: (state) => ({
      ...state,
      isInvited: true,
    }),
    [actionTypes.SET_BROKER_INVITED_STATUS]: (state) => ({
      ...state,
      isBrokerInvited: true,
    }),
    [actionTypes.SET_JOURNEY_ACCOUNT_TYPE]: (state, { payload }) => {
      const updatedState = {
        ...state,
        userJourneyAccountType: payload.userJourneyAccountType,
      };
      return updatedState;
    },
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
